module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.shovValidate ? 'v-textarea showError' : 'v-textarea'
  }, [_c('div', {
    class: _vm.valid ? 'v-textareaWrapper complete' : 'v-textareaWrapper incomplete'
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "name": _vm.data.name,
      "text": _vm.data.text,
      "required": _vm.data.required,
      "placeholder": _vm.data.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.test,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ea0760"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/textarea.vue
// module id = 264
// module chunks = 38